var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemaleSignBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 47,
    viewBox: "0 0 32 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7823 0C7.08231 0 0 7.07538 0 15.7754C0 23.4831 5.57308 29.9169 12.8677 31.2854V36.0531H8.73231C7.27154 36.0531 6.09 37.2392 6.09 38.6977C6.09 40.1562 7.27154 41.3423 8.73231 41.3423H12.8677V44.3123C12.8677 45.7731 14.0538 46.9569 15.5146 46.9569C16.9754 46.9569 18.1638 45.7685 18.1638 44.3123V41.3423H22.5069C23.9677 41.3423 25.1515 40.1515 25.1515 38.6977C25.1515 37.2323 23.9677 36.0531 22.5069 36.0531H18.1638V31.3708C25.7585 30.2169 31.5554 23.6631 31.5554 15.7754C31.5554 7.07538 24.4823 0 15.7823 0ZM15.7823 26.2592C9.99692 26.2592 5.29385 21.5538 5.29385 15.7708C5.29385 9.98769 9.99692 5.28231 15.7823 5.28231C21.5631 5.28231 26.2685 9.98769 26.2685 15.7708C26.2685 21.5538 21.5654 26.2592 15.7823 26.2592Z",
    fill: "#e91e63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleSignBlack);
export default __webpack_public_path__ + "static/media/FemaleSignBlack.d8687664d06e764cf54ca35990666723.svg";
export { ForwardRef as ReactComponent };